export const system = "Intake" as const;
